var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"border mt-1"},[_c('b-col',[_c('small',[_vm._v("Response")]),_c('div',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.essayResponse),expression:"essayResponse"}]})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }